import { useMediaQuery } from 'react-responsive'

const useMediaQueryHook = () => {
  const minQuery = '(min-width: 0px) and (max-width: 360px)'
  const mobileQuery = '(min-width: 360px) and (max-width: 600px)'
  const tabletQuery = '(min-width: 600px) and (max-width: 1200px)'
  const pcQuery = '(min-width: 1200px)'

  const mediaList = [
    { type: 'min', value: useMediaQuery({ query: minQuery }) },
    { type: 'mobile', value: useMediaQuery({ query: mobileQuery }) },
    { type: 'tablet', value: useMediaQuery({ query: tabletQuery }) },
    { type: 'pc', value: useMediaQuery({ query: pcQuery }) },
  ]

  const currentMedia = mediaList.find(({ value }) => value)?.type

  const setMediaStyle = (pc?: any, tablet?: any, mobile?: any) => {
    return currentMedia === 'tablet' ? tablet : currentMedia === 'pc' ? pc : mobile
  }

  return {
    currentMedia,
    setMediaStyle,
  }
}
export default useMediaQueryHook
